:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 0 0 calc(var(--spacer) * 2);
}

gz-labeled-content::part(label) {
  width: 35%;
  display: flex;
  align-items: center;
}

gz-labeled-content::part(content) {
  width: 65%;
}

.copy-labeled-content {
  margin-top: -4px;
}

.copy-icon {
  width: 36px;
}

.footer {
  margin-top: auto;
  padding: 12px 0;
  display: flex;
  align-items: center;
  gap: 16px;
}

.content-with-icon {
  display: flex;
  align-items: center;
  gap: calc(var(--spacer) * 0.5);
}
